import { LINK_COPY } from './linkCopy';
import { LinkPage } from './LinkPage';
import { VolunteerModeSelector } from './VolunteerModeSelector';

/**
 * Manage ARC › Volunteer Recruitment: the external form behind the ARC's
 * Volunteer button (US-100), under the Recruitment Method choice (P9, P10).
 */
export function VolunteerPage() {
  return (
    <LinkPage
      kind="volunteer"
      copy={LINK_COPY.volunteer}
      modeSelector={(view, writable, error) => (
        <VolunteerModeSelector
          value={view.mode}
          disabled={!writable}
          error={error ?? undefined}
        />
      )}
    />
  );
}
